import axios from "axios";

import { MAX_REQUEST_TIMEOUT } from "../constants/requests";

export const serverURL = process.env.REACT_APP_SERVER_URL as string;

const API = axios.create({
  baseURL: serverURL,
  headers: { "Content-Type": "application/json" },
  timeout: MAX_REQUEST_TIMEOUT,
});

API.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem("jwt");
    if (jwt) {
      config.headers["Authorization"] = `Bearer ${jwt}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default API;
